import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const GestionPagosModal = ({ show, onClose, onSave, showCreate, title, initDataPagos, metodosPago }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, getValues: getValuesModal, setValue : setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
   
    const [amountDisabled, setAmountDisabled] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

    useEffect(() => {
        resetModal();
        if (initDataPagos !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('nroCuota', initDataPagos.nroCuota);
            setValueModal('cuota', initDataPagos.montoCuota);
            setValueModal('saldo', initDataPagos.saldo);
            // setDetalles(initDataPagos.detalles);
        }
    }, [initDataPagos]);


    const changeTipoAccion = (value) => {
        let object = CONFIGURACIONES.INIT.TIPOS_ACCION;  
        setAmountDisabled(CONFIGURACIONES.INIT.STATUS_FALSE);
        setValueModal('importe', '');
        if(value == object.PAGAR) {
            setAmountDisabled(CONFIGURACIONES.INIT.STATUS_TRUE);
            setValueModal('importe', initDataPagos.saldo);
        }
    };
    
    const saveData = (form) => {
        let data = {
            tipoAccion: form.tipoAccion,
            medioPagoId: form.medioPagoId,
            saldo: initDataPagos.saldo,
            importe: (amountDisabled == CONFIGURACIONES.INIT.STATUS_FALSE?form.importe:initDataPagos.saldo),
            nroOperacion: form.nroOperacion
        }
        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(saveData)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="nroCuota" className="control-label col-form-label">N° Cuota <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="nroCuota"
                                        id="nroCuota"
                                        {...registerModal("nroCuota", {
                                            required: OWASP.REQUIRED,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.nroCuota && errorsModal.nroCuota.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="cuota" className="control-label col-form-label">Cuota <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="cuota"
                                        id="cuota"
                                        {...registerModal("cuota", {
                                            required: OWASP.REQUIRED,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.cuota && errorsModal.cuota.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="saldo" className="control-label col-form-label">Saldo <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="saldo"
                                        id="saldo"
                                        {...registerModal("saldo", {
                                            required: OWASP.REQUIRED,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.saldo && errorsModal.saldo.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row">      
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="tipoAccion" className="control-label col-form-label">Tipo de Acción <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("tipoAccion", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                changeTipoAccion(e.target.value);
                                            }
                                        })} className="form-control" id="tipoAccion"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            CONFIGURACIONES.INIT.LIST.TIPO_ACCIONES.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.tipoAccion && errorsModal.tipoAccion.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="medioPagoId" className="control-label col-form-label">Medio de Pago <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("medioPagoId", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })} className="form-control" id="medioPagoId"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            metodosPago.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.medioPagoId && errorsModal.medioPagoId.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="nroOperacion" className="control-label col-form-label">N° de Operación <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="nroOperacion"
                                        id="nroOperacion"
                                        {...registerModal("nroOperacion", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.nroOperacion && errorsModal.nroOperacion.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="importe" className="control-label col-form-label">Importe <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="importe"
                                        id="importe"
                                        {...registerModal("importe", {
                                            required: OWASP.REQUIRED,
                                            disabled: amountDisabled,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.importe && errorsModal.importe.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default GestionPagosModal;
